import { render } from "./PostCommetDetailsPage.vue?vue&type=template&id=47247990&scoped=true"
import script from "./PostCommetDetailsPage.vue?vue&type=script&lang=js"
export * from "./PostCommetDetailsPage.vue?vue&type=script&lang=js"

import "./PostCommetDetailsPage.vue?vue&type=style&index=0&id=47247990&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47247990"]])

export default __exports__